<!-- Assign Points component -->
<script>
import axios from "axios";
import Tabs from "../shared/components/tabs/tabs.vue";
import { Money } from "v-money";
import Errors from "../shared/components/errors-page/errors.vue";
import StoreHeader from "../shared/components/store-header/store-header.vue";
import StoreFooterMobile from "../shared/components/store-footer-mobile/store-footer-mobile.vue";

export default {
  data() {
    return {
      networkError:false,
      error: false,
      error401: false,
      error500: false,
      errorOther: false,
      pts: 0,
      selectedManagers: [],
      assignManagers: [],
      submitAssignManager: [],
      managerNames: [],
      total: [],
      successResponseData: {},
      modalShow: false,
      modalWeb: false,
      disableNextButton: true,
      transactionId: null,
      isNextButtonActive: false,
      money: {
        decimal: ",",
        thousands: ",",
        prefix: "$",
        precision: 0,
        masked: false
      },
      minimumAmountRequired: 0
    };
  },
  created () {
    this.minimumAmountRequired = process.env.VUE_APP_MIN_AMOUNT_FOR_POINTS ? Number(process.env.VUE_APP_MIN_AMOUNT_FOR_POINTS) : 1
  },
  mounted () {
    this.pts = this.$store.getters.pointRate
    this.isNextButtonActive = false
  },
  beforeMount() {
    if (navigator.onLine) {
      this.networkError=false;
      this.error = false;
    } else {
      this.error = true;
      this.networkError=true
    }
    this.selectedManagers = this.$store.state.selectedManagers;
    if (this.$store.state.assignedManagers.managers !== undefined) {
      this.assignManagers = this.$store.state.assignedManagers.managers
    } else {
      this.$store.state.managerNames.map(allManagers => {
        this.selectedManagers.map(selectedManager => {
          if (selectedManager === allManagers.pin) {
            this.assignManagers.push({
              pin: allManagers.pin,
              points: "",
              price: 0,
              name: allManagers.fName,
              // role: allManagers.orgnodeName
            });
          }
        });
      })
    }
  },
  components: {
    Tabs,
    Money,
    Errors,
    StoreHeader,
    StoreFooterMobile
  },
  computed: {
    points: function() {
      let pointsrate = this.$store.getters.pointRate
      return this.assignManagers.reduce(function(acc, item) {
        return (
          acc + Math.floor(Number(item.price) * (1 / pointsrate))
        );
      }, 0);
    },
    totals: function() {
      return this.assignManagers.reduce(function(acc, item) {
        return acc + Number(item.price);
      }, 0);
    }
  },
  methods: {
    nextPage() {
      let pointsrate = this.$store.getters.pointRate
      this.assignManagers.map(manager => {
        let value = Number(
            manager.price * (1 / pointsrate)
        );
        this.submitAssignManager.push({
          pin: manager.pin,
          points: value,
          price: manager.price,
          name: manager.name,
          // role: manager.role
        });
      });
      const pin = this.$store.state.pin
      const orgnodeCode = this.$route.params.code;
      let storeName = this.$store.state.storeName
      const data = {
        member_pin: pin,
        price: this.totals,
        points: this.points,
        orgnode_code: orgnodeCode,
        province: this.$store.state.province,
        storeName: storeName,
        managers: this.submitAssignManager
      };
      if (this.$store.state.assignedManagers.managers) {
        data.transaction_id = this.$store.state.assignedManagers.transaction_id
      }
      this.isNextButtonActive = true
      axios
          .post(`${process.env.VUE_APP_API_URL}/Points/Assign`, data, {
            withCredentials: true
          })
          .then(res => {
            this.successResponseData = res.data;
            this.transactionId = res.data.transaction_id;
            if (this.successResponseData.managers.length > 0) {
              this.$store.commit(
                  "updateAssingedManagers",
                  this.successResponseData
              );
              this.$router.push(`/assign/confirm/${this.transactionId}`);
            }
          }, 1000)
          .catch(error => {
            if (error.response === undefined) {
              if (error.response.data.error.status === 401) {
                this.error = true;
                this.error401 = true;
              } else if (error.response.data.error.status === 500) {
                this.error = true;
                this.error500 = true;
              } else {
                this.error = true;
                this.errorOther = true;
              }
            } else {
              this.error = true;
              this.errorOther = true;
            }
          });
    },
    backPage() {
      this.$store.commit(
        "updateAssingedManagers",
        {
          managers: this.assignManagers
        }
      );
      this.$router.back();
    },
    deleteManager(index) {
      let deletedData = {...this.assignManagers[index]}
      if (index > -1) {
        this.assignManagers.splice(index, 1);
      }
      if (this.assignManagers.length === 0) {
        this.disableNextButton = true;
      }
      this.assignManagers.map(manager => {
        if (manager.price === 0) {
          this.disableNextButton = true;
        } else {
          this.disableNextButton = false;
        }
      });
      let selectedManagers = this.$store.state.selectedManagers.filter(val => {
        return val !== deletedData.pin
      })
      this.$store.commit("updateSelectedManagers", selectedManagers);
    },
    hideTooltip() {
      this.$root.$emit("bv::hide::tooltip", "my-trigger-button-id");
    },
    launchInfo() {
      this.modalShow = true;
    },
    validateInput() {
      if (this.$refs.assignManager) {
        let managersWithZeroValue = this.$refs.assignManager.find(fieldInput => {
          return fieldInput.value < this.minimumAmountRequired || fieldInput.value === undefined
        })
        if (managersWithZeroValue !== undefined) {
          this.disableNextButton = true;
        } else {
          this.disableNextButton = false;
        }
      }
    },
    modalwebHandler() {
      this.modalWeb = !this.modalWeb;
    }
  },
  name: "assign-points"
};
</script>

<!-- Template -->
<template>
  <fragment>
    <div v-if="!error" class="container-fluid">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-md-12 offset-md-0 mobilepadall">
          <div class="hide-on-mob">
            <!-- Store Header --Start -->
            <store-header
              @back="backPage"
              info="yes"
              nextbtn="yes"
              @next="nextPage()"
              :disabled="disableNextButton"
            ></store-header>
            <!-- Store Header --end -->
          </div>

          <div @click="hideTooltip()">
            <!-- Tabs --Start-->
            <tabs
              tabTitle2="active"
              tabNumber2="active-number"
              border1="inactive-border"
              border2="active-border"
              border3="inactive-border"
            ></tabs>
            <!-- Tabs --end -->
            <!--Main Container --Start-->
            <div class="main-container">
              <b-row
                class="justify-content-md-center container-section m-0 pb-0 pad-lf-rt-24"
              >
                <b-col
                  lg="6"
                  md="6"
                  sm="6"
                  class="pl-0 mobile-margin selfalign"
                >
                  <div class="select-manager-title">
                    <h3>{{ $t("message.assignpointsTableHeading") }}</h3>
                  </div>
                </b-col>
                <b-col
                  lg="6"
                  md="6"
                  sm="6"
                  class="pr-0 pl-0 mobile-margin selfalign"
                >
                  <div class="rate-card">
                    <div class="convert-rate">
                      $1 = {{ Math.floor(1 / pts) }} points
                    </div>
                    <div class="rate-info" v-if="minimumAmountRequired > 0">
                      {{ $t("message.minPurchaseNote", [minimumAmountRequired]) }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <!-- Web Table --Start-->
              <div class="hide-on-mob">
                <div class="container-heading-row">
                  <div class="checkbox-section border-right"></div>
                  <div class="col title-section border-right">
                    <span>{{ $tc("message.assignedTableHeading", 0) }}</span>
                  </div>
                  <div class="col id-section border-right">
                    <span class="float-right">{{
                      $tc("message.assignedTableHeading", 1)
                    }}</span>
                  </div>
                  <div class="col role-section text-left">
                    <span class="float-right">{{
                      $tc("message.assignedTableHeading", 2)
                    }}</span>
                  </div>
                </div>
                <b-form>
                  <div class="points-container-body">
                    <div
                      class="container-body-row assign-points"
                      v-for="(manager, index) in assignManagers"
                      :key="index"
                    >
                      <div class="checkbox-section">
                        <img
                          class="close-assign"
                          src="../../assets/close-square.svg"
                          alt
                          @click="deleteManager(index)"
                        />
                      </div>
                      <div class="col title-section text-capitalize p-assign">
                        <span>{{ manager.name }}</span>
                      </div>
                      <div class="col id-section text-uppercase p-assign">
                        <span class="float-right">
                          {{
                            Math.floor(
                              Number((1 / pts) * manager.price)
                            ).toLocaleString()
                          }}
                        </span>
                      </div>

                      <div class="col role-section text-right">
                        <money
                          class="budget-input"
                          v-model.lazy="manager.price"
                          v-bind="money"
                          placeholder="Enter $ Value"
                          ref="assignManager"
                          :name="`assignManagers[${index}]`"
                          @input="validateInput"
                        ></money>
                      </div>
                    </div>
                  </div>
                  <div class="container-total-row">
                    <div class="empty-container"></div>
                    <div class="order-container">
                      <div class="your-points">
                        {{ Number(points).toLocaleString() }} points
                      </div>
                    </div>
                    <div class="cost-container">
                      <span
                        class="total-cost"
                        >${{ Number(totals).toLocaleString() }}</span
                      >
                    </div>
                  </div>
                </b-form>
              </div>
              <!-- Web Table --End-->
              <!-- Mobile Table --Start  -->
              <div class="mobileVisible">
                <div class="container-heading-row-mobile">
                  <div class="title-section">
                    <span>{{ $tc("message.assignedTableHeading", 0) }}</span>
                  </div>
                </div>
                <div class="assign-container-body">
                  <div
                    class="container-body-row-mobile assign-points"
                    v-for="(manager, index) in assignManagers"
                    :key="index"
                  >
                    <div class="checkbox-section-mobile">
                      <img
                        class="close-assign"
                        src="../../assets/close-square.svg"
                        alt
                        @click="deleteManager(index)"
                      />
                    </div>
                    <div class="title-section-mobile text-capitalize p-assign">
                      <span>{{ manager.name }}</span>
                      <div
                        class="id-section-mobile text-capitalize p-assign"
                        style="padding-top: 4px"
                      >
                        <span>
                          <strong
                            >{{
                              $tc("message.assignedTableHeading", 1)
                            }}:</strong
                          >
                          {{ Math.floor(Number((1 / pts) * manager.price)) }}
                        </span>
                      </div>
                    </div>

                    <div class="assign-section-mobile">
                      <money
                        class="budget-input text-left"
                        v-model.lazy="manager.price"
                        v-bind="money"
                        placeholder="Enter $ Value"
                        ref="assignManager"
                        :name="`assignManagers[${index}]`"
                        @input="validateInput"
                      ></money>
                    </div>
                  </div>
                </div>
                <div class="mobile-amount-container">
                  <div class="order-container">
                    <span class="your-order">
                      {{ $tc("message.yourOrderPoints", 0) }}:
                      <br />
                      {{ Math.floor(Number(points)) }} points
                    </span>
                    <span></span>
                  </div>
                  <div class="cost-container">
                    <span
                      class="total-cost"
                      :class="[totals < 50 ? 'danger' : 'success']"
                      >${{ totals | formatNumber }}</span
                    >
                  </div>
                </div>

                <store-footer-mobile
                  @back="backPage"
                  info="yes"
                  nextbtn="yes"
                  @next="nextPage()"
                  @LInfo="launchInfo"
                  :disabled="disableNextButton"
                ></store-footer-mobile>
                <b-modal
                  class="confirm-modal"
                  hide-backdrop
                  v-model="modalShow"
                  >{{ $t("message.toolTipText", [minimumAmountRequired]) }}</b-modal
                >
              </div>
              <!--====end===-->
              <!-- Mobile Table end  -->
            </div>
            <!--Main Container --End-->
          </div>
        </div>
      </div>
    </div>
    <errors
      v-else
      :errorNetworkrErrorprops="this.networkError"
      :error401props="this.error401"
      :error500props="this.error500"
      :errorOtherprops="this.errorOther"
    ></errors>
  </fragment>
</template>

<!-- Style -->
<style lang="scss">
.container-total-row {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  height: 7.6vh;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  background-color: white;
}

.points-container-body {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-top: none;
  box-sizing: border-box;
  border-radius: 0;
  margin: auto;
  overflow: auto;
  max-height: 39vh;
  height: 39vh;
}
.your-points {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  background-color: var(--success);
  border-radius: 5px;
  min-width: 117px;
  max-width: 100%;
  padding: 9px;
  align-items: center;
  text-align: right;
  color: #ffffff;
  align-self: center;
}
.order-container {
  position: relative;
  width: 14%;
  padding-left: 8px;
  border: none;
  align-self: center;
}

.empty-container {
  position: relative;
  width: 50%;
  border: none;
  border-right: 1px solid rgba(229, 229, 229, 0.4);
}

.alert-inf:focus {
  outline: none;
}

.tooltip.b-tooltip {
  opacity: 1;
}

.tooltip-inner {
  position: absolute;
  background-color: #323232;
  color: #fff;
  border: 1px solid #45505b;
  box-sizing: border-box;
  border-radius: 2px;
  left: -274px;
  top: -6px;
  padding: 12px;
  font-size: 14px;
  width: 276px;
  max-width: 276px;
  text-align: left;
}

.tooltip .arrow::before {
  display: none;
  // border-left: 1px solid black;
}

.cost-container {
  position: relative;
  width: 36%;
  padding-right: 24px;
  border: none;
  align-self: center;
}

.total-cost {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  align-items: center;
  text-align: right;
  letter-spacing: -0.1px;
  display: block;
  color: var(--primary-bg) !important;
}
.total-cost.danger {
  color: var(--primary-bg);
}

.p-assign {
  padding: 26px;
}

.budget-input {
  background: #ffffff;
  border-radius: 5px;
  height: 48px;
  width: 150px;
  text-align: right;
  padding: 16px;
  border: 1px solid #c1c8cf;
}

.budget-input:focus {
  border: 1px solid #c1c8cf;
}

input:focus {
  border: 1px solid #c1c8cf;
}

.close-assign {
  width: 18px;
  height: 18px;
  margin: 13px 5px;
}
.rate-card {
  text-align: right;
}

.rate-card .convert-rate {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  margin: 2px 0 2px 40%;
  color: var(--primary-bg);
  opacity: 0.87;
  display: block;
}
.rate-card .rate-info {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #687888;
  display: block;
}
.form-input {
  width: 100%;
}
.form-input label {
  position: relative;
  display: block;
  width: 100%;
  min-height: 45px;
}
.form-input .placeholder {
  position: absolute;
  display: block;
  top: 16px;
  z-index: 2;
  font-size: 16px;
  transition: all 200ms ease-in-out;
  width: 100%;
  cursor: text;
  color: #c1c8cf;
}
.form-input input,
.form-input textarea {
  position: absolute;
  top: 15px;
  z-index: 1;
  width: 100%;
  font-size: 16px;
  border: 0;
  border-bottom: 1px solid grey;
  transition: border-color 200ms ease-in-out;
  outline: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
}
.form-input textarea {
  min-height: 30px;
  padding: 8px 0;
}
.form-input input {
  height: 30px;
}
.form-input input:focus,
.form-input input:valid,
.form-input textarea:focus,
.form-input textarea:valid {
  border-bottom: 2px solid #1a38b1;
}
.form-input input:focus + .placeholder,
.form-input input:valid + .placeholder,
.form-input textarea:focus + .placeholder,
.form-input textarea:valid + .placeholder {
  top: 0;
  cursor: inherit;
  font-size: 14px;
  color: #c1c8cf;
}
.display-none {
  display: none;
}

.assign-table .table td {
  padding: 0;
  vertical-align: middle;
}
.mobile-table {
  display: none;
}

.mobile-input-data {
  display: none;
}

@media (max-width: 600px) {
  .container-total-row {
    display: none;
  }
  .container-total-row-mobile {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    float: right;
    width: 100%;
    height: 72px;
    border-bottom: 1px solid rgba(229, 229, 229, 0.4);
    border-left: 1px solid rgba(229, 229, 229, 0.4);
    border-right: 1px solid rgba(229, 229, 229, 0.4);
  }

  .order-container {
    width: 50%;
  }
  .cost-container {
    width: 93%;
    padding-right: 0;
  }
  .assign-section-mobile {
    position: absolute;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    top: 65px;
    left: 18%;
    color: #687888;
    width: 75%;
  }
  .assign-points {
    height: 134px;
  }
  .your-order {
    position: absolute;
    top: 25%;
    left: 8%;
    font-style: normal;
    font-size: 12px;
    color: #828282;
    width: 100%;
    font-weight: 600;
  }
  .p-assign {
    padding: 8px 0 0 0;
  }
  .assign-table {
    display: none;
  }
  .mobile-table {
    display: block;
  }
  .budget-input {
    width: 100%;
    font-size: 16px;
  }
  .mobile-table .input-group-prepend,
  .input-group-text {
    height: 48px;
    background: #45505b;
    border-radius: 5px 0px 0px 5px;
    color: white;
    width: 60%;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 14px;
  }
  .input-table {
    height: 48px;
    background: #f5f5f5;
    border: none;
    margin-bottom: 14px;
  }
  .input-table:focus {
    border: 1px solid #2f80ed;
    box-sizing: border-box;
    box-shadow: none;
    background: #f5f5f5;
  }
  .input-label {
    font-style: normal;
    font-weight: 500;
    font-size: 27px;
    line-height: 24px;
    text-align: right;
    padding-right: 20px;
    letter-spacing: 0.1px;
    color: #687888;
    width: 45%;
    margin: auto 0;
  }

  .mobile-input-data {
    display: block;
  }

  .input-data {
    width: 55%;
    border: none;
    height: 59px;
    font-size: 42px;
    font-weight: 500;
    caret-color: #45505b;
  }

  .input-data:focus {
    box-sizing: border-box;
    box-shadow: none;
  }

  .amount-detail {
    text-align: center;
    display: block;
  }
  .amount-detail span {
    display: block;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #687888;
    opacity: 0.8;
  }

  .mobile-amount-container {
    position: fixed;
    width: 100%;
    bottom: 64px;
    margin: auto;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    height: 64px;
    padding: 13px 0px;
  }

  .next-btn-container-mobile {
    position: fixed;
    width: 100%;
    bottom: 0px;
    margin: auto;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    height: 64px;
  }
  .alert-inf {
    padding: 7px;
    margin: 0px;
  }

  .modal-dialog {
    position: absolute;
    bottom: 9%;

    box-sizing: border-box;
    border-radius: 2px;
    height: 82px;
    width: 90%;
    margin: 0 5%;
  }
  .modal-dialog .modal-header {
    position: absolute;
    right: 5px;
    border-bottom: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    padding: 0;
  }
  .modal-dialog .modal-footer {
    display: none;
  }
  .modal-dialog .modal-body {
    text-align: left;
    font-size: 15px;
    padding: 15px 33px 15px 25px;
  }
  .modal-content {
    color: #fff;
    background: #323232;
  }
  .modal-content .close {
    color: #fff;
    display: none;
  }
}

// mobile Media queries
@media (max-width: 320px) {
  .assign-container-body {
    height: 30vh;
    max-height: 30vh;
  }
}

@media (max-width: 360px) and (min-width: 321px) {
  .assign-container-body {
    height: 38vh;
    max-height: 38vh;
  }
}

@media (max-width: 411px) and (min-width: 361px) {
  .assign-container-body {
    height: 48vh;
    max-height: 48vh;
  }
}
@media (min-width: 370px) and (max-width: 375px) {
  .assign-container-body {
    height: 41vh;
    max-height: 41vh;
  }
}
@media (max-width: 540px) and (min-width: 500px) {
  .assign-container-body {
    height: 48vh;
    max-height: 48vh;
  }
}
@media (max-height: 736px) and (min-height: 731px) {
  .assign-container-body {
    height: 49vh;
    max-height: 49vh;
  }
}
@media (min-height: 800px) and (max-height: 823px) {
  .assign-container-body {
    height: 51vh;
    max-height: 51vh;
  }
}
</style>

